export default class Deploys {
  client

  constructor(client) {
    this.client = client
  }

  /**
   * Get deploy stats
   * @param {Object} params - The deploy parameters
   * @param {string} params.site_id - The site ID
   * @param {string} params.revision - The revision
   * @param {string} [params.namespace] - Optional namespace
   * @param {Object} [options={}] - Optional request options
   * @returns {Promise} The API response
   */
  stats(params, options = {}) {
    return this.client.post("/api/v2/deploys/stats", params, options)
  }
}
